import { orderDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDate"
import {billingAddressStyles} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsBillingAddress"
import {orderDetailsButtonSetStyles} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet"
import { paymentTermsStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsPaymentTerms"
import { requestedDateStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsRequestedDate"
import { shippingAddressStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingAddress"
import {shippingMethodStyles} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsShippingMethod"
import { statusStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsStatus"
import {summaryTableStyles} from "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable"
import { titleStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsTitle"
import { orderPoStyles } from "@insite/content-library/Widgets/OrderDetails/OrderPo"
import { orderSalespersonStyles } from "@insite/content-library/Widgets/OrderDetails/OrderSalesperson"
import { BaseTheme } from "@insite/mobius/globals/baseTheme"
import { breakpointMediaQueries } from "@insite/mobius/utilities"
import getColor from "@insite/mobius/utilities/getColor"
import { TYPOGRAPHY } from "@tCentro/theme/design"
import { css } from "styled-components"

orderDetailsButtonSetStyles.reorderButton = {
    mergeCss: true,
    css: css`
        display: flex;
        align-items: center;
    `,
}

orderDetailsButtonSetStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            button {
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
}

billingAddressStyles.wrapper = {
    css: css`
        padding-bottom: 10px;
    `,
}

billingAddressStyles.titleText = {
    variant: "h5",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: ${TYPOGRAPHY.size.base} !important;
        padding-top: 10px;
        margin-top: 0 !important;
    `,
}

shippingAddressStyles.titleText = {
    variant: "h5",
    css: css`
        @media print {
        font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: ${TYPOGRAPHY.size.base} !important;
        padding-top: 10px;
        margin-top: 0 !important;
    `,
}

shippingMethodStyles.titleText = {
    variant: "h5",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: ${TYPOGRAPHY.size.base} !important;
        padding-top: 10px;
    `,
}

orderDateStyles.titleText = {
    variant: "h5",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: ${TYPOGRAPHY.size.base} !important;
    `,
}

summaryTableStyles.orderLines = {
    gridContainer: {
        css: css`
            .card_container__wrapper {
                border-top: 1px solid ${getColor("common.border")};
            }
            .card_container__wrapper ~ .card_container__wrapper {
                border-top: none;
            }
        `,
    },
    orderLineCardAddToListGridItem: {
        css:css`
            padding: 15px 10px;
        `,
    },
    productInfoQtyOrderedGridItem: {
        css:css`
            padding: 5px 0px;
        `,
    },
    productInfoErpNumberGridItem:{
        css:css`
            padding-right: 10px; 
        `,
    }
}

statusStyles.titleText = {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: ${TYPOGRAPHY.size.base} !important;
            line-height: ${TYPOGRAPHY.lineHeight.base} !important;
            font-weight: ${TYPOGRAPHY.weight.mediumbold} !important;
        `,
}

paymentTermsStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size: ${TYPOGRAPHY.size.base} !important;
    `,
}

orderPoStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size:${TYPOGRAPHY.size.base} !important;
    `,
}

orderSalespersonStyles.titleText = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size:${TYPOGRAPHY.size.base} !important;
    `,
}

requestedDateStyles.titleText={
    variant: "h6",
    as: "h3",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
        font-size:${TYPOGRAPHY.size.base} !important;
    `,
}

titleStyles.titleText={
    variant: "h2",
    as: "h1",
    css: css`
        @media all and (min-width: 576px) and (max-width: 1199px) {
            font-size: ${TYPOGRAPHY.size.xxlarge};
        }
    `,
}
